module.exports = __webpack_public_path__ + "img/no-complete.354a5529.png";